import {someList, unwrapList} from "@platejs/list-classic";
import {NodeType} from "../../utils";
import {
    type TElement,
} from 'platejs';

export const isBlockActive = (editor, formats: string[] = []) => {
    const [match] = editor.api.nodes({
        match: n => {
            return formats.indexOf(n.type) > -1;
        },
    });

    return !!match;
};

export const toggleBlock = (editor, format: string) => {
    const isList = someList(editor, NodeType.UNORDERED_LIST) || someList(editor, NodeType.ORDERED_LIST);
    editor.tf.withoutNormalizing(() => {
        if (isList) {
            unwrapList(editor);
        }
        editor.tf.toggleBlock(format);
    })
};

export const getBlockType = (block: TElement) => {
    return block.type;
};
